import { useEffect, useState } from 'react';

const isPlainObject = (value) =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value);

// useState backed by localStorage, so filters and sorting survive a reload.
// Object defaults are merged over, so a stored value keeps working when the
// filter gains a field later.
export default function usePersistedState(key, defaultValue) {
  const [value, setValue] = useState(() => {
    try {
      const raw = localStorage.getItem(key);
      if (raw === null) return defaultValue;

      const parsed = JSON.parse(raw);
      return isPlainObject(defaultValue) && isPlainObject(parsed)
        ? { ...defaultValue, ...parsed }
        : parsed;
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    // storage may be full or blocked, which must not break the page
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      /* noop */
    }
  }, [key, value]);

  return [value, setValue];
}
